import { Field, useFormikContext } from "formik";
import marker_icon from 'assets/images/svgs/marker-line-icon.svg';
import hospital_icon from 'assets/images/hospital_1.png';
import AllInstitutesTypeaheadField from "./AllInstitutesTypeaheadField";
import { createImageFromInitials, getRandomColor } from "utils/Utils";
import { encrypt } from "utils/EncryptDecrypt";

const JobCreateFormTwoForAdmin = (props) => {
  const { values } = useFormikContext();
  return (
    <>
      <div className="nex-job-form-left-sec">
        <div className="nex-job-info">
          <img src={hospital_icon} alt="" className="graphic" />
          <div className="conts">
            <p><span className='light'>1/7</span> Job Post</p>
            <h2 className='title'>Let’s start with the hospital you want to go with...</h2>
            <p className='lead'>Choose the Hospital that you are creating a job for</p>
          </div>
        </div>
      </div>
      <div className="nex-job-form-right-sec">
        <Field
          id="institutionDetail"
          name="institutionDetail"
          type="text"
          label="Search for the Institution"
          placeholder="Search and select"
          component={AllInstitutesTypeaheadField}
        />

        {values?.institutionDetail && values?.mainItemName &&
          <div
            key={values?.institutionDetail}
            className={`nex-radio-hospital active`}
          >
            {/* <div className="graphic">
              {values.avatarId ? (
                <img
                  src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${values.institutionDetail}/${values.avatarId}`}
                  className="card-img"
                  alt="#"
                />
              ) : (
                <img
                  src={createImageFromInitials(
                    50,
                    `${values.mainItemName}`,
                    getRandomColor(encrypt(values?.institutionDetail).toString())
                  )}
                  className="card-img"
                  alt="#"
                />
              )}
            </div> */}
            <div className="info">
              <h3 className='nex-text-xl' >{values.mainItemName}</h3>
              <p className="nex-text text-black bold">
                <span className='icon'>
                  <img src={marker_icon} alt="" />
                </span>
                {values.mainItemName}
              </p>
            </div>
          </div>
        }
      </div>
    </>
  );
}

export default JobCreateFormTwoForAdmin;
